import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { ID } from "@ehealth_tools/common/src/data/propertyTypes/property.types";
import { BookingElementTypes } from "../booking/booking.model";
import { UnavailabilityDTO } from "./availability.dto";
import { CompanyAffectationDTO, CompanyDTO } from "./company.dto";
import { PermissionDTO } from "./permission.dto";
import { PermissionCategoryDTO } from "./permissionCategory.dto";
import { RoleDTO } from "./role.dto";
import { PatientInfosDTO, ProfessionalInfosDTO, UserDTO } from "./user.dto";
import { UserRoleDTO } from "./userRole.dto";

export type UsersElementTypes = {
    "user_profiles": UserDTO,
    "professional_infos": ProfessionalInfosDTO,
    "patient_infos": PatientInfosDTO,
    "user_roles": RoleDTO,
    "user_permissions": PermissionDTO,
    "user_permission_categories": PermissionCategoryDTO,
    "user_profiles_roles": UserRoleDTO,
    "companies": CompanyDTO,
    "company_affectations": CompanyAffectationDTO,
    "unavailabilities": UnavailabilityDTO
}

type UsersAssociationTypes = {
    "user_roles_permissions": { roleId: ID, permissionId: ID }
}

export type UsersElementTypeName = keyof UsersElementTypes;
export const UsersElementTypeNames: UsersElementTypeName[] = keys<UsersElementTypes>();

export const usersTypeInfos: ETTypeInfos<UsersElementTypes, UsersElementTypes & UsersAssociationTypes & BookingElementTypes> = {

    "user_profiles": {
        keys: keys<UserDTO>(),
        typeInfos: typeInfos<UserDTO>(),
        archivedField: "archived",
        foreignKeys: {
            referralId: "user_roles",
            calendarId: "booking_calendars"
        }
    },
    "professional_infos": {
        keys: keys<ProfessionalInfosDTO>(),
        typeInfos: typeInfos<ProfessionalInfosDTO>(),
        foreignKeys: {
            userId: "user_profiles"
        }
    },
    "patient_infos": {
        keys: keys<PatientInfosDTO>(),
        typeInfos: typeInfos<PatientInfosDTO>(),
        foreignKeys: {
            userId: "user_profiles"
        }
    },
    "user_roles": {
        keys: keys<RoleDTO>(),
        typeInfos: typeInfos<RoleDTO>(),
        associations: {
            permissionIds: {
                name: "user_roles_permissions",
                ownerColumn: {
                    name: "roleId",
                    foreignTable: "user_roles"
                },
                associateColumn: {
                    name: "permissionId",
                    foreignTable: "user_permissions"
                }
            }
        }
    },
    "user_permission_categories": {
        keys: keys<PermissionCategoryDTO>(),
        typeInfos: typeInfos<PermissionCategoryDTO>()
    },
    "user_profiles_roles": {
        keys: keys<UserRoleDTO>(),
        typeInfos: typeInfos<UserRoleDTO>(),
        foreignKeys: {
            roleId: "user_roles",
            userId: "user_profiles",
            companyId: "companies"
        }
    },
    "user_permissions": {
        keys: keys<PermissionDTO>(),
        typeInfos: typeInfos<PermissionDTO>(),
        foreignKeys: {
            categoryId: "user_permission_categories"
        }
    },
    "companies": {
        keys: keys<CompanyDTO>(),
        typeInfos: typeInfos<CompanyDTO>(),
        associations: {
            userIds: {
                name: "company_affectations",
                ownerColumn: {
                    foreignTable: "companies",
                    name: "companyId"
                },
                associateColumn: {
                    foreignTable: "user_roles",
                    name: "userId"
                }
            }
        },
        archivedField: "archived"
    },
    "company_affectations": {
        keys: keys<CompanyAffectationDTO>(),
        typeInfos: typeInfos<CompanyAffectationDTO>(),
        foreignKeys: {
            companyId: "companies",
            userId: "user_profiles"
        }
    },
    "unavailabilities": {
        keys: keys<UnavailabilityDTO>(),
        typeInfos: typeInfos<UnavailabilityDTO>(),
        foreignKeys: {
            userId: "user_profiles"
        }
    }
};